import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import React, { useCallback, useRef, useState } from 'react';
import * as Yup from 'yup';
import { useToast } from '../../../hooks/toast';
import getValidationErrors from '../../../utils/getVaidationErrors';
import Buttom from '../../forms/Buttom';
import ReactSelectCreateForm from '../../forms/ReactSelectCreateForm';

import {
  postCreateSellerSubjectItem,
  postProviderSubjectItems,
} from '../../../services/api';

import Modal from '../Modal';

import { Container, Bottom, Row } from './styles';
import { useAuth } from '../../../hooks/auth';
import { saveManageSubjectsLog } from '../../../services/logs';

interface IItems {
  sellerId?: string;
  itemId: string;
  itemContentId: string;
  title: string;
}

interface IModalProps {
  selectedItem: IItems;
  isOpen: boolean;
  setIsOpen: () => void;
}

const ModalDisciplina: React.FC<IModalProps> = ({
  selectedItem,
  isOpen,
  setIsOpen,
}) => {
  const { user } = useAuth();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const handleSubmit = useCallback(
    async data => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          subjectId: Yup.string().required('Campo Obrigatório'),
        });
        await schema.validate(data, {
          abortEarly: false,
        });

        if (user.type === 'seller' || user.type === 'seller_content_manager') {
          await postCreateSellerSubjectItem({
            subjectId: data.subjectId,
            itemId: selectedItem.itemId,
            itemContentId: selectedItem.itemContentId,
          });
        } else if (user.type === 'provider') {
          await postProviderSubjectItems({
            subjectId: data.subjectId,
            subjectItems: [
              {
                itemId: selectedItem.itemId,
                itemContentId: selectedItem.itemContentId,
                order: 2,
              },
            ],
          });
        }

        // saveManageSubjectsLog({
        //   userId: user.id,
        //   action: 'added_item_to_subject',
        //   itemId: selectedItem.itemId,
        //   itemContentId: selectedItem.itemContentId,
        //   subjectId: data.subjectId,
        // });

        saveManageSubjectsLog({
          userId: user.id,
          sellerId: user.seller?.id || '',
          action: 'added_item_to_subject',
          itemId: selectedItem.itemId,
          itemContentId: selectedItem.itemContentId,
          subjectId: data.subjectId,
        });

        addToast({
          title: 'Unidade organizada com sucesso!',
          type: 'success',
        });
        setIsOpen();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
          return;
        }
        addToast({
          title: 'Ops...',
          type: 'error',
          description: 'Algo inesperado aconteceu.',
        });
      } finally {
        setLoading(false);
      }
    },
    [
      user.type,
      addToast,
      setIsOpen,
      selectedItem.itemId,
      selectedItem.itemContentId,
    ],
  );
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <Container>
        <h1>Adicionar à disciplina</h1>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Row>
            <label>
              Para qual disciplina gostaria de enviar a unidade &quot;
              {selectedItem.title}&quot;?
            </label>
            <ReactSelectCreateForm
              name="subjectId"
              placeholder="Selecione ou digite para buscar"
            />
          </Row>
          <button type="submit" hidden>
            submeter
          </button>
        </Form>
        <Bottom>
          <Buttom
            name="cancelar"
            type="button"
            onClick={() => setIsOpen()}
            label="Cancelar"
            outline
          />
          <Buttom
            name="salvar"
            onClick={() => formRef.current?.submitForm()}
            label="Salvar"
            isLoading={loading}
          />
        </Bottom>
      </Container>
    </Modal>
  );
};

export default ModalDisciplina;
